<template>
    <div class="List">
        <van-row>
            <van-col span="12" style="border-right: 1px solid #e3e3e3" @click="listBtnShow('left')">筛选</van-col>
            <van-col span="12" @click="listBtnShow('right')">排序</van-col>
        </van-row>
        <div class="listCon">
            <p>
                共检索到 <span>{{ totalNum || 0 }} </span> 篇文章
            </p>
            <van-list v-model="listLoading" :finished="listFinished" :immediate-check="false" offset="10" finished-text="没有更多了">
                <slot name="list"></slot>
                <div v-show="listShow" class="noData">
                    暂无数据
                </div>
                <p v-if="error" class="err">请求失败，点击重新加载 <van-button @click="retry()">重新加载</van-button></p>
            </van-list>
        </div>
        <van-popup v-model="listLefShow" position="left" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="分组浏览" />
            <slot name="listLeft"></slot>
        </van-popup>
        <van-popup v-model="listRightShow" position="right" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="排序" />
            <div class="right">
                <van-cell v-for="(item1, index1) in orderByData" :key="index1" :class="{ active: item1.value == listCurrent }">
                    <template slot="title">
                        <span class="custom-title" @click="listFacetCick(item1.value)">{{ item1.title }}</span>
                        <van-icon :name="item1.sort" v-if="item1.sort" style="font-size: 1.3rem; vertical-align: middle; margin-left: 5px;" />
                    </template>
                </van-cell>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    props: ["orderByData", "totalNum"],
    data() {
        return {
            listShow: false, // 暂无数据显示隐藏
            error: false, //中国知网cnki -99 重新加载
            listLoading: false, // loading显示隐藏
            listFinished: false, // 没有更多了显示隐藏
            listLefShow: false, // 筛选显示隐藏
            listRightShow: false, // 排序显示隐藏
            listCurrent: "", // 选中排序
            onLoadShow: true
        };
    },
    mounted() {
        // let that = this;
        window.addEventListener("scroll", this.scrollFun);
    },
    methods: {
        scrollFun() {
            let that = this;
            //变量scrollTop是滚动条滚动时，距离顶部的距离search
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                //写后台加载数据的函数
                if (this.onLoadShow) {
                    that.$parent.onLoad();
                }
            }
        },
        listBtnShow(val) {
            if (val == "left") {
                this.listLefShow = true;
            } else if (val == "right") {
                this.listRightShow = true;
            }
        },
        listFacetCick(val) {
            this.$parent.orderByCick(val);
        },
        retry() {
            this.$parent.search();
        }
    },
    deactivated() {
        window.removeEventListener("scroll", this.scrollFun);
    }
};
</script>
<style lang="less">
.List {
    .van-row {
        border-bottom: 1px solid #e3e3e3;
        height: 2.5rem;
        padding: 0.7rem 0;
        background: #fff;

        .van-col--12 {
            color: #09718b;
            text-align: center;
        }
    }

    .listCon {
        margin-top: 0.8rem;
        background: #fff;

        > p {
            padding: 1rem 1rem 0 1rem;
            color: #9a9a9a;
        }

        .van-list {
            .con {
                border-bottom: 1px solid #e3e3e3;
                padding: 1rem;

                h4 {
                    a {
                        color: #4b4b4b;
                        word-break: break-word;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }

                    font-weight: 400;
                }

                p {
                    margin-bottom: 0.4rem;
                    font-size: 0.9rem;

                    span {
                        color: #9a9a9a;
                    }
                }
            }
            .noData {
                text-align: center;
                margin: 2rem;
                color: #9a9a9a;
            }
        }
    }

    .van-radio__label {
        width: 100%;
    }

    .right {
        .van-cell__title {
            width: 100%;
            text-align: center;
        }
    }
}

.van-popup {
    > .van-cell {
        border-bottom: 1px solid #ebedf0;

        > .van-cell__title {
            > span {
                font-size: 1rem;
                font-weight: 700;
            }
        }
    }

    .van-collapse {
        .van-radio-group {
            > div {
                padding-bottom: 10px;
            }
        }
    }
    .right {
        .active {
            color: red;
        }
    }
}
</style>
